<template>
  <b-container fluid>
    <b-row>
      <b-col>

        <b-card :title="value.studyName" class="mb-2">
          <div>{{value.varName}}</div>
            <b-form-input type="text" v-model="valueModel" @input="onInputChange" @change="onModelChanged" :list="value.varName"></b-form-input>

            <datalist :id="value.varName">
                <option v-for="(suggest,idx) in suggestions" :key="idx">{{ suggest.title }}</option>-->
            </datalist>

              <div v-for="(varValue, idx) in value.values" :key="idx">
                  <span class="badge badge-primary">
                    {{varValue}}
                      <button type="button" class="close" aria-label="Dismiss" @click="removeValue(idx)">
                        <span aria-hidden="true">&times;</span>
                      </button>
                  </span>
              </div>

        </b-card>

      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import UserService from "../../services/UserService";
import _ from 'lodash'

  export default {
    name: 'UserVariableComponent',

    components: {
    },

    props: [ 'value' ],

    data() {
      return {
          valueModel: "",
          suggestions: []
      }
    },

    computed: {
        ...mapState(['activeSurvey', 'absoluteDrillPath']),
        ...mapGetters(['realmName', 'studyName', 'authToken', 'pageByName', 'completePath']),
    },

    created(){
      this.loadSuggestions("*")
    },

     methods: {
        removeValue(idx) {
            this.value.values.splice(idx,1);
            this.$emit('input', this.value )
        },

        onModelChanged(e) {
            // console.log("Change:" + e)
            if(e.length>0) {
                this.value.values.push(e)
                this.valueModel = ""
                this.$emit('input', this.value )
            }
        },

         onInputChange(e) {
             // console.log("Input:" + e)
             if(!_.isEmpty(e)) {
               this.loadSuggestions(e)
             }
         },

         loadSuggestions(part) {
           UserService.getVariableSuggestions(this.authToken, this.realmName, this.value.studyName, this.value.varName, part).then((response) => {
             this.suggestions = response.data
           })
         }





     },

  }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .close {
        padding-right: 0px;
        padding-left: 4px;
        margin-right: 4px;
        font-size: inherit;
        color: inherit;
        text-shadow: none;
}

</style>